import { useAuth } from '../context/AuthContext';
import { eContatto } from '../utils/contatto';

/**
 * Vero quando l'utente loggato è un Contatto: account `cliente` attivo senza
 * Cliente su NTS, che lo diventa al primo ordine. Unico punto da cui l'app
 * decide cosa nascondere (`utils/contatto.ts`).
 */
export function useContatto(): boolean {
  const { user } = useAuth();
  return eContatto(user);
}
